class ProductMediaGallery extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    super.show(opener);
    this.showMedia(this.openedBy.dataset.mediaId);
  }

  showMedia(id) {
    const galleryMedia = this.querySelector(`[data-media-id="${id}"]`);

    if (!galleryMedia) {
      return;
    }

    if (window.innerWidth < 990) {
      this.querySelectorAll('[data-media-id]').forEach((media) => {
        media.style.display = 'none';
      })
      galleryMedia.style.display = 'block';

      return;
    }

    this.querySelectorAll('[data-media-id]').forEach((media) => {
      media.style.display = 'block';
    })
    galleryMedia.scrollIntoView();
  }
}

customElements.define('product-media-gallery', ProductMediaGallery);
